import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';

const useFetchDropdowns = (id: string) => {
  const [dropdowns, setDropdowns] = useState<any>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        setLoading(true);
        const data = await DealsService.getDealDropdowns(id);

        setDropdowns(data.data);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setDropdowns({});
      } finally {
        setLoading(false);
      }
    };

    fetchDropdowns();
  }, [id]);

  return {
    loading,
    dropdowns,
  };
};

export default useFetchDropdowns;
